var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberHelpColdFormed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4, .cls-5 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: silver;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 1.34px;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.47px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.8px;\r\n      }\r\n\r\n      .cls-6 {\r\n        font-size: 8.82px;\r\n        stroke: 0;\r\n        fill: #000;\r\n        font-family: ArialMT, Arial;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MemberHelpColdFormed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MemberColdFormed"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "151.06 155.13 151.06 140.5 148.97 140.5 148.97 153.04 111.37 153.04 111.37 48.6 148.97 48.6 148.97 61.13 151.06 61.13 151.06 46.51 109.28 46.51 109.28 155.13 148.97 155.13 151.06 155.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.06,
    y1: 46.51,
    x2: 109.28,
    y2: 46.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 109.28,
    y1: 46.51,
    x2: 109.28,
    y2: 155.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 109.28,
    y1: 155.13,
    x2: 151.06,
    y2: 155.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.06,
    y1: 155.13,
    x2: 151.06,
    y2: 140.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.06,
    y1: 140.5,
    x2: 148.97,
    y2: 140.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 148.97,
    y1: 140.5,
    x2: 148.97,
    y2: 153.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 148.97,
    y1: 153.04,
    x2: 111.37,
    y2: 153.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 111.37,
    y1: 153.04,
    x2: 111.37,
    y2: 48.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 111.37,
    y1: 48.6,
    x2: 148.97,
    y2: 48.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 148.97,
    y1: 48.6,
    x2: 148.97,
    y2: 61.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 148.97,
    y1: 61.13,
    x2: 151.06,
    y2: 61.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.06,
    y1: 61.13,
    x2: 151.06,
    y2: 46.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.09,
    y1: 42.33,
    x2: 91.09,
    y2: 159.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 91.09,
    y1: 155.13,
    x2: 89,
    y2: 153.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 91.09,
    y1: 155.13,
    x2: 93.18,
    y2: 157.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.09,
    y1: 155.13,
    x2: 86.91,
    y2: 155.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.09,
    y1: 155.13,
    x2: 105.1,
    y2: 155.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 91.09,
    y1: 46.51,
    x2: 89,
    y2: 44.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 91.09,
    y1: 46.51,
    x2: 93.18,
    y2: 48.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.09,
    y1: 46.51,
    x2: 86.91,
    y2: 46.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.09,
    y1: 46.51,
    x2: 105.1,
    y2: 46.51
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(88.39 112.42) rotate(-90)"
  }, "Depth"), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 105.1,
    y1: 30.37,
    x2: 155.24,
    y2: 30.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 151.06,
    y1: 30.37,
    x2: 148.97,
    y2: 32.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 151.06,
    y1: 30.37,
    x2: 153.15,
    y2: 28.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 151.06,
    y1: 30.37,
    x2: 151.06,
    y2: 26.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 151.06,
    y1: 30.37,
    x2: 151.06,
    y2: 42.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 109.28,
    y1: 30.37,
    x2: 107.19,
    y2: 32.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 109.28,
    y1: 30.37,
    x2: 111.37,
    y2: 28.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 109.28,
    y1: 30.37,
    x2: 109.28,
    y2: 26.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 109.28,
    y1: 30.37,
    x2: 109.28,
    y2: 42.33
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(118.76 27.67)"
  }, "Width"), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 165.6,
    y1: 42.33,
    x2: 165.6,
    y2: 65.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 165.6,
    y1: 61.13,
    x2: 163.51,
    y2: 59.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 165.6,
    y1: 61.13,
    x2: 167.68,
    y2: 63.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 165.6,
    y1: 61.13,
    x2: 169.77,
    y2: 61.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 165.6,
    y1: 61.13,
    x2: 155.24,
    y2: 61.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 165.6,
    y1: 46.51,
    x2: 163.51,
    y2: 44.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 165.6,
    y1: 46.51,
    x2: 167.68,
    y2: 48.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 165.6,
    y1: 46.51,
    x2: 169.77,
    y2: 46.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 165.6,
    y1: 46.51,
    x2: 155.24,
    y2: 46.51
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(169.59 57.08)"
  }, "Lip"), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 144.79,
    y1: 127.31,
    x2: 155.24,
    y2: 127.31
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "150.01 127.31 150.44 125.03 151.63 123.09 153.43 121.8 155.54 121.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 151.06,
    y1: 127.31,
    x2: 148.97,
    y2: 129.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 151.06,
    y1: 127.31,
    x2: 153.15,
    y2: 125.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 151.06,
    y1: 127.31,
    x2: 151.06,
    y2: 123.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 151.06,
    y1: 127.31,
    x2: 151.06,
    y2: 136.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 148.97,
    y1: 127.31,
    x2: 146.88,
    y2: 129.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 148.97,
    y1: 127.31,
    x2: 151.06,
    y2: 125.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 148.97,
    y1: 127.31,
    x2: 148.97,
    y2: 123.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 148.97,
    y1: 127.31,
    x2: 148.97,
    y2: 136.33
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(155.54 124.61)"
  }, "Thickness"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberHelpColdFormed);
export default __webpack_public_path__ + "static/media/MemberHelpColdFormed.a012de324e6c67207c76ec291eabbded.svg";
export { ForwardRef as ReactComponent };